export default {
  data() {
    return {
      administradoras: [],
    };
  },
  methods: {
    async getAdministradorasPorUsuario() {
      try {
        const { data: administradoras } = await this.$http.post('/inventory.get-card-administrator', { isPDV: true });
        return administradoras.map((item) => ({
          ...item,
          name: item.name,
        }));
      } catch (err) {
        return [];
      }
    },
    async getAdministradoras() {
      this.administradoras = [
        ...await this.getAdministradorasPorUsuario(),
      ];
    },
  },
};
